export default {
  type: 'in_place',
  instanceName: 'registrar/zero/user',
  modalClassName: 'registar-zero-user',
  fields: {
    email: { type: 'text' },
    name: { type: 'text' },
    phone: { type: 'text', fieldType: 'phone', apiType: 'phone' },
    checkAgreement: { type: 'bool' },
    checkPersonalInfo: { type: 'bool' }
  }
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/registrarUserFormConfig.js